export default "__VITE_ASSET__76$qr2lo__"